import { useDispatch } from "react-redux";
import { reset } from "features/auth/authSlice";

const SIGNOUT_URL = process.env.REACT_APP_SIGNOUT_URL!;

const useSignOut = () => {
  const dispatch = useDispatch();

  return () => {
    dispatch(reset());
    window.location.replace(SIGNOUT_URL);
  };
};

export { useSignOut };
